import { useQuery } from '@tanstack/vue-query'

const api = useApi()

async function getCurrentCustomerProfile(currentCustomerId) {
  const customer = await api.retrieveCustomer(currentCustomerId)
  return [customer]
}

async function getCustomerFamilyProfiles(family) {
  const profiles = await api.listCustomers({
    queryParameters: {
      family,
    },
  })
  return profiles.results
}

function createInstance() {
  const { sessionData, currentCustomerId } = useSessionData()
  if (!currentCustomerId)
    return {}
  const family = sessionData.current_customer?.family?.id
  if (!family) {
    return useQuery({
      queryKey: ['profiles'],
      queryFn: async () => getCurrentCustomerProfile(currentCustomerId),
    })
  }

  else {
    return useQuery({
      queryKey: ['profiles'],
      queryFn: async () => getCustomerFamilyProfiles(family),
    })
  }
}

export const useProfilesQuery = useSingleton(createInstance)
